import * as React from "react";
const SvgBluetooth20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M9 .131 17.803 6l-6 4 6 4L9 19.869v-8l-4.445 2.963-1.11-1.664L8.197 10 3.445 6.832l1.11-1.664L9 8.13v-8Zm2 11.737L14.197 14 11 16.131v-4.263Zm0-3.737V3.868L14.197 6 11 8.131Z",
      clipRule: "evenodd"
    })
  );
export default SvgBluetooth20Px;
